export class PUIHDataReq {
  constructor(
    public id: number,
    public title: string,
    public text: string,
    public path: string,
    public status: number,
    public deleted: boolean
  ) {}
}

export class PostUpsertHeaderReq {
  constructor(
    public data: PUIHDataReq
  ) {
  }
}
